module.exports = __webpack_public_path__ + "static/media/OpenSans-Semibold.08952b02.woff2";